import { Navigate } from "react-router-dom";

/**
 * Global /strategy route — redirects to corporates list.
 * Strategy is corporate-scoped; use /corporate/:id/policies instead.
 */
export default function Strategy() {
  return <Navigate to="/corporates" replace />;
}
